import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { AppState, ShowRequest } from '../../core';
import { PathWaypointService, PathWaypointDoc, PointService } from '../../core/services';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { Subscription } from 'rxjs';
import { MapWaypoint } from '../../core/models/mapping';
import { PointDoc } from '../../core/schema/point-schema';
import { sortByNumericWaypointOrder, WaypointTableRow } from '../../core/models/path-waypoint';




@Component({
  selector: 'app-waypoint-list',
  templateUrl: './waypoint-list.component.html',
  styleUrls: ['./waypoint-list.component.scss']
})
export class WaypointListComponent extends FesBaseComponent implements OnInit, OnDestroy {

  waypointTableRows : WaypointTableRow[] = []

  isLoading : boolean = false;
  @Input() pathId : string
  @Output('waypoints') waypointsEmitter = new EventEmitter<PathWaypointDoc[]>()
  @Output('mapWaypoints') mapWaypointsEmitter = new EventEmitter<MapWaypoint[]>()
  @Output('pinClicked') pinClickedEmitter = new EventEmitter<MapWaypoint>()
  selectedId : string

  waypointsQuerySubscription: Subscription
  pointsQuerySubscription: Subscription


  constructor(appState:AppState,
      private waypointService : PathWaypointService,
      private pointService: PointService ) {
    super(appState)
  }


  ngOnInit(): void {
    this.waypointService.doWhenReady( () => this.initWaypointsQuery() )
  }


  ngOnDestroy(): void {
    this.destroy()
    this.waypointsQuerySubscription?.unsubscribe()
    this.pointsQuerySubscription?.unsubscribe()
  }


  async initWaypointsQuery() {
    this.isLoading = true
    //this.selectedId = null

    const pathWaypointsQuery = this.waypointService.rxCollection.find().where('pathId').eq(this.pathId)
    this.waypointsQuerySubscription?.unsubscribe()

    this.waypointsQuerySubscription = pathWaypointsQuery.$.subscribe( async waypoints => {
      waypoints.sort( sortByNumericWaypointOrder )
      this.waypointsEmitter.emit(waypoints)
      this.waypointTableRows = waypoints.map( wp => new WaypointTableRow( new MapWaypoint(wp.toJSON(),null) ))
      const mapWaypoints = this.waypointTableRows.map(row=>row.mapWaypoint)
      let pointsQuery = this.pointService.rxCollection.findByIds$(waypoints.map(wp=>wp.pointId))
      this.pointsQuerySubscription?.unsubscribe()
      this.pointsQuerySubscription = pointsQuery.subscribe( (pointsById: Map<string,PointDoc>) => {
        this.waypointTableRows.forEach( row => {
          row.setPoint( pointsById.get(row.mapWaypoint?.pointId)?.toJSON() )
        })
        try {
        this.waypointService.updatePathContext(mapWaypoints)
        } catch ( error ) {
          this.pointService.publishError(error,this)
        }
        this.mapWaypointsEmitter.emit(mapWaypoints)
        this.isLoading = false
      },
      (error) => {
        this.pointService.publishErrorObj(error,`Points query for waypoints ${waypoints?.map(wp=>wp._id)}, pathId='${this.pathId}'`,this)
      })
    },
    (error) => {
      this.waypointService.publishErrorObj(error,`Waypoints query failed for pathId='${this.pathId}'`,this)
      this.isLoading = false
    })
  }


  onShowPoint( pointId : string ) {
    this.appState.showView.next( new ShowRequest('tab','point',pointId) )
  }


  onPinClick( wp : MapWaypoint ) {
    this.selectedId = wp?.id
    this.pinClickedEmitter.emit(wp)
  }

}
